import React from "react";
import { useForm } from "react-hook-form";
import CipHeader from "./CipHeader";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";

import cogoToast from "cogo-toast";
import { selectBarCode } from "../state/reducers/barCodeResultSlice";
import moment from "moment";
import {
  selectReturns,
  setReturnsList,
} from "../state/reducers/returnsListSlice";
import returnService from "../services/return-service";

const ReturnForm = ({ history }) => {
  const dispatch = useDispatch();
  const { barCodeDetails } = useSelector(selectBarCode);

  let { itemsList } = useSelector(selectReturns);

  // react hook form
  const { register, handleSubmit, errors, watch, setValue, getValues } =
    useForm({});
  const watchAllFields = watch();
  const submitScan = async (data, event) => {
    submitReturn(data, "submitScan");
  };
  const submitClose = async (data, event) => {
    submitReturn(data, "submitClose");
  };
  async function submitReturn(data, typeAction) {
    if (parseInt(data.disp_quantity) >= parseInt(data.quantity)) {
      const params = {
        rxCode: data.barcode,
        serial: data.serial,
        facilityId: barCodeDetails?.length ? barCodeDetails[0].facilityId : "",
        returnedQuantity: data.quantity,
        inmatePossession: false,
        facilityName: data.facilityName,
        drugId: data.drugId,
        drugName: data.drug_name,
        strength: data.strength,
        dosage: data.dosage,
        inmateId: data.inmateId,
        inmateAcct: data.inmate_number,
        inmateName: data.inmate_name,
        dispensedQuantity: data.disp_quantity,
        dispensedDate: data.dispDate,
      };
      try {
        const returnedData = await returnService.addReturn(params);
        if (returnedData) {
          const { hide } = cogoToast.success("Returned Successfully..", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
          if (data.dispense_date) {
            let selectedDateData = JSON.parse(data.dispense_date);
            let updatedData = { ...selectedDateData, ...returnedData };
            //updating the state
            let returns = [...itemsList];
            returns.unshift(updatedData);
            dispatch(setReturnsList(returns));
            if (typeAction === "submitScan") {
              await history.push("/barcode-search");
            } else if (typeAction === "submitClose") {
              await history.push("/returns");
            }
          }
        }
      } catch (e) {
        console.info(e);
        const { hide } = cogoToast.error(
          "Error saving Return. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    } else {
      const { hide } = cogoToast.error(
        "Returned Quantity should be less than Dispensed Quantity",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  }

  function handleChange(e) {
    const getDetails = watchAllFields.dispense_date;
    if (getDetails) {
      const temp = JSON.parse(watchAllFields.dispense_date);
      setValue("serial", temp.serial, { shouldValidate: true });
      setValue("disp_quantity", temp.dispensedQuantity, {
        shouldValidate: true,
      });
      setValue("dispDate", temp.dispensedDate, { shouldValidate: true });
    }
  }

  function fullqty_btn(e) {
    setValue("quantity", getValues("disp_quantity"), { shouldValidate: true });
  }

  return (
    <>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-6 h-24">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">RETURNS APPLICATION</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <form>
            <ul className="text-left">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Barcode (S)
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <input
                  id="barcode"
                  name="barcode"
                  type="text"
                  placeholder="Barcode (S)"
                  autoComplete=""
                  ref={register({
                    required: "You must specify the barcode",
                  })}
                  defaultValue={barCodeDetails[0].rxCode}
                  className=" text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full"
                />
                {errors.barcode && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.barcode?.message}
                  </p>
                )}
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  RX Code
                </label>

                <input
                  id="rx_code"
                  name="rx_code"
                  type="text"
                  placeholder="RX code"
                  autoComplete=""
                  defaultValue={barCodeDetails[0].rxCode}
                  ref={register({
                    required: "You must specify the rx_code",
                  })}
                  readOnly={true}
                  className="text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full"
                />
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Facility
                </label>

                <input
                  type="text"
                  name="facilityName"
                  defaultValue={barCodeDetails[0].facilityName}
                  readOnly={true}
                  ref={register({
                    required: false,
                  })}
                  className="text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full"
                />
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Drug
                </label>
                <input
                  id="drug_name"
                  name="drug_name"
                  type="text"
                  placeholder="Drug"
                  autoComplete=""
                  readOnly={true}
                  defaultValue={
                    barCodeDetails[0].drugName +
                    " " +
                    barCodeDetails[0].strength +
                    " " +
                    barCodeDetails[0].dosage
                  }
                  ref={register({
                    required: "You must specify the Drug",
                  })}
                  className="text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full"
                />
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Inmate Name
                </label>

                <input
                  id="inmate_name"
                  name="inmate_name"
                  type="text"
                  placeholder="Inmate Name"
                  autoComplete=""
                  readOnly={true}
                  ref={register({
                    required: false,
                  })}
                  defaultValue={barCodeDetails[0].inmateName}
                  className="text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full"
                />
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Inmate Number
                </label>

                <input
                  id="inmate_number"
                  name="inmate_number"
                  type="text"
                  placeholder="Inmate Number"
                  autoComplete=""
                  readOnly={true}
                  ref={register({
                    required: false,
                  })}
                  defaultValue={
                    barCodeDetails[0].inmateAcct === "-"
                      ? ""
                      : barCodeDetails[0].inmateAcct
                  }
                  className="text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full"
                />
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Dispensed Date
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <select
                  id="dispense_date"
                  name="dispense_date"
                  aria-label="dispense date"
                  ref={register({
                    required: "You must specify the Dispense Date",
                  })}
                  onChange={handleChange}
                  className={` ${
                    errors.dispense_date ? "border-red-400" : ""
                  } text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full`}
                >
                  <option value="">Select</option>
                  {barCodeDetails.map((barCodedet, index) => (
                    <option
                      key={index}
                      value={JSON.stringify(barCodedet)}
                      selected={barCodeDetails.length === 1 ? "true" : ""}
                    >
                      {moment
                        .utc(barCodedet.dispensedDate)
                        .format("MMMM DD YYYY")}
                    </option>
                  ))}
                </select>
                {errors.dispense_date && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.dispense_date?.message}
                  </p>
                )}
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Dispensed Quantity
                </label>
                <input
                  id="disp_quantity"
                  name="disp_quantity"
                  type="number"
                  autoComplete=""
                  readOnly={true}
                  defaultValue={
                    barCodeDetails.length === 1
                      ? barCodeDetails[0].dispensedQuantity
                      : ""
                  }
                  ref={register({
                    required: "You must specify the Dispensed Quantity",
                  })}
                  className="text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full"
                />
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Sequence
                </label>
                <input
                  id="serial"
                  name="serial"
                  type="number"
                  placeholder="Sequence No"
                  autoComplete=""
                  readOnly={true}
                  ref={register({
                    required: "You must specify the Sequence No",
                  })}
                  defaultValue={
                    barCodeDetails.length === 1 ? barCodeDetails[0].serial : ""
                  }
                  className="text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full"
                />
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Quanity Returned
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <p>
                  <span className="inline-block w-3/5">
                    <input
                      id="quantity"
                      name="quantity"
                      type="number"
                      placeholder="Quantity Returned"
                      autoComplete=""
                      ref={register({
                        required: "You must specify the Quantity",
                      })}
                      className={` ${
                        errors.quantity ? "border-red-400" : ""
                      } text-fogotpwsd_login placeholder-fogotpwsd_login border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full`}
                    />
                  </span>
                  <span className="inline-block w-1/3 float-right">
                    <input
                      onClick={fullqty_btn}
                      type="button"
                      value="Full Return"
                      className="border-2 border-ret_qty w-full bg-menuHvrColor text-menuHvrColor font-bold py-2 focus:outline-none focus:none"
                    />
                  </span>
                  {errors.quantity && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      {errors.quantity?.message}
                    </p>
                  )}
                </p>
              </li>
              <li>
                <input
                  type="text"
                  name="drugId"
                  defaultValue={barCodeDetails[0].drugId}
                  ref={register({
                    required: false,
                  })}
                  className="hidden"
                />
                <input
                  type="text"
                  name="strength"
                  defaultValue={barCodeDetails[0].strength}
                  ref={register({
                    required: false,
                  })}
                  className="hidden"
                />
                <input
                  type="text"
                  name="dosage"
                  defaultValue={barCodeDetails[0].dosage}
                  ref={register({
                    required: false,
                  })}
                  className="hidden"
                />
                <input
                  type="text"
                  name="inmateId"
                  defaultValue={barCodeDetails[0].inmateId}
                  ref={register({
                    required: false,
                  })}
                  className="hidden"
                />
                <input
                  type="text"
                  name="dispDate"
                  ref={register({
                    required: false,
                  })}
                  className="hidden"
                  defaultValue={barCodeDetails[0].dispensedDate}
                />
              </li>

              <li className="inline-block text-sm leading-8 mb-3 w-1/3">
                <button
                  type="button"
                  className="rounded font-semibold tracking-wider h-10 text-white w-11/12 bg-secondary bg-login_btn mb-3 focus:outline-none"
                  aria-label="submit"
                  data-tag="scanNew"
                  onClick={handleSubmit(submitScan)}
                >
                  SUBMIT & SCAN NEW RX
                </button>
              </li>
              <li className="inline-block text-sm leading-8 mb-3 w-1/3">
                <button
                  type="button"
                  className="rounded font-semibold tracking-wider h-10 text-white w-11/12 bg-secondary bg-login_btn mb-3 focus:outline-none"
                  aria-label="submit"
                  data-tag="scanClose"
                  onClick={handleSubmit(submitClose)}
                >
                  SUBMIT & CLOSE
                </button>
              </li>
              <li className="inline-block text-sm leading-8 mb-3 w-1/3">
                <Link
                  className="text-white rounded font-semibold tracking-wider bg-secondary bg-login_btn focus:outline-none px-20 py-3"
                  to="/barcode-search"
                >
                  CANCEL
                </Link>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(ReturnForm)
);
